import script from "./StandardAddDistrictDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StandardAddDistrictDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__